import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionActivityDataForm } from '../_models/session-activity-data-form';

@Injectable({
  providedIn: 'root'
})
export class SesssionActivityService {

  public static readonly URL_SESSION_ACTIVITY_CONTROLLER_CONTROLLER = environment.apiUrl + '/sessionActivity/';

  public static readonly URL_SAVE_USER_SESSIONACTIVITY = SesssionActivityService.URL_SESSION_ACTIVITY_CONTROLLER_CONTROLLER + "saveUserSession/";
  public static readonly URL_GET_USER_SESSIONACTIVITY = SesssionActivityService.URL_SESSION_ACTIVITY_CONTROLLER_CONTROLLER + "getLastSessionByUserId/";
  public static readonly URL_GET_USER_SESSIONACTIVITY_PERCENTAGE = SesssionActivityService.URL_SESSION_ACTIVITY_CONTROLLER_CONTROLLER + "getLastSessionPercentageByUserId/";
  
  
  public static readonly URL_GET_USER_PROJECT_SESSION_ACTIVITY = SesssionActivityService.URL_SESSION_ACTIVITY_CONTROLLER_CONTROLLER + "getLastProjectSessionUserId/";
  public static readonly URL_GET_USER_PROJECT_SESSION_FOR_REDIRECTION = SesssionActivityService.URL_SESSION_ACTIVITY_CONTROLLER_CONTROLLER + "getLastProjectSessionRedirectionUserId/";
  
  public static readonly URL_GET_USER_PROJECT_PERNCENTAGE= SesssionActivityService.URL_SESSION_ACTIVITY_CONTROLLER_CONTROLLER + "getProjectLastSessionPercentageByUserId/";
  
  
  
  constructor(private http: HttpClient, private authService: AuthService) { }

  // save user SessionActivity 
  saveUesrSessionActiity(sessionActivityDataForm: SessionActivityDataForm) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(SesssionActivityService.URL_SAVE_USER_SESSIONACTIVITY + userToken,sessionActivityDataForm)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  getLastSessionActiityByUserId(id,activityType) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(SesssionActivityService.URL_GET_USER_SESSIONACTIVITY + id + '/'  +activityType + '/'+userToken,id,activityType)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  getLastSessionActiityPercentageByUserId(id) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(SesssionActivityService.URL_GET_USER_SESSIONACTIVITY_PERCENTAGE + id + '/'+userToken,id)
      .pipe(catchError(this.handleError('Request Failed')));
  }


  
  getProjectLastSessionActiityByUserId(id,activityType,projectId) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(SesssionActivityService.URL_GET_USER_PROJECT_SESSION_ACTIVITY + id + '/'  +activityType + '/' + projectId + '/'+userToken,id,activityType)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  getProjectLastSessionActiityForRedirection(id,activityType,projectId) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(SesssionActivityService.URL_GET_USER_PROJECT_SESSION_FOR_REDIRECTION + id + '/'  +activityType + '/' + projectId + '/'+userToken,id,activityType)
      .pipe(catchError(this.handleError('Request Failed')));
  }


  getProjectPercentageActiityByUserId(id,activityType,projectId) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(SesssionActivityService.URL_GET_USER_PROJECT_PERNCENTAGE + id + '/'  +activityType + '/' + projectId + '/'+userToken,id,projectId,)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse) => {
      console.log(error);
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
      return Observable.throw(error);
    };
  }
}
